import React from "react";

/**
 * Shared "basic mode" score card used by all sport scoreboards.
 * IS the participant card itself (single box, no nesting) — the whole card
 * is the tappable +1 target; a small "−1" correction button sits in its
 * bottom-right corner.
 */
const BasicScoreBox = ({
  participantClassName,
  score,
  disabled = false,
  subDisabled = false,
  onIncrease,
  onDecrease,
  addLabel,
  subLabel,
  children,
}) => {
  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onIncrease();
    }
  };

  return (
    <div
      className={`participant-websocket ${participantClassName} participant-websocket--clickable${disabled ? " participant-websocket--disabled" : ""}`}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-label={addLabel}
      aria-disabled={disabled}
      onClick={() => !disabled && onIncrease()}
      onKeyDown={handleKeyDown}
    >
      {children}
      <span className="participant-score-large">{score}</span>
      <button
        type="button"
        className="vb-deduct-btn vb-deduct-btn--corner"
        onClick={(e) => { e.stopPropagation(); onDecrease(); }}
        disabled={subDisabled}
        aria-label={subLabel}
      >
        −1
      </button>
    </div>
  );
};

export default BasicScoreBox;
